// React for Website

import React from "react";
//outsource
import { Form, Input } from "antd";

//components

const StaffUserName = ({ disabled }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="username"
      label="Username"
      // rules={[
      //   {
      //     required: true,
      //     message: "Please input username",
      //   },
      // ]}
    >
      <Input placeholder="username" disabled={disabled} />
    </Form.Item>
  );
};

export default StaffUserName;
